<template>
    <app-layout>
      <Head title="Settings"/>
        <template #header>
            <h2 class="font-semibold text-xl text-gray-800 leading-tight">
                Settings
            </h2>
        </template>

        <div>
            <div class="max-w-7xl mx-auto py-10 sm:px-6 lg:px-8">
                <jet-form-section @submitted="updateSettings">
                    <template #title>
                        Notification Preferences
                    </template>

                    <template #description>

                    </template>

                    <template #form>
                        <div class="col-span-6">
                            <label class="flex items-center">
                                <input
                                    type="checkbox"
                                    class="form-checkbox"
                                    v-model="form.incoming_message_alerts"
                                    :checked="form.incoming_message_alerts"
                                />
                                <span class="ml-2 text-sm text-gray-600">
                                    Receive email alerts on incoming messages to {{$page.props.auth.user.email}}. Update your account email in
                                    <Link
                                        href="/user/profile"
                                        class="text-blue-600"
                                    >
                                        your profile
                                    </Link>
                                    .
                                </span>
                            </label>
                        </div>
                    </template>
                    <template #actions>
                        <jet-action-message :on="form.recentlySuccessful" class="mr-3">
                            Saved.
                        </jet-action-message>

                        <jet-button
                            :class="{ 'opacity-25': form.processing }"
                            :disabled="form.processing"
                        >
                            Save
                        </jet-button>
                    </template>
                </jet-form-section>
            </div>
        </div>
    </app-layout>
</template>

<script>
import AppLayout from "../../Layouts/AppLayout";
import JetButton from "./../../Jetstream/Button";
import JetFormSection from "./../../Jetstream/FormSection";
import JetInput from "./../../Jetstream/Input";
import JetInputError from "./../../Jetstream/InputError";
import JetLabel from "./../../Jetstream/Label";
import JetActionMessage from "./../../Jetstream/ActionMessage";
import JetSecondaryButton from "./../../Jetstream/SecondaryButton";



export default {
    name: 'UserSettingsPage',
    props: ["sessions"],
    components: {
        AppLayout,
        JetActionMessage,
        JetButton,
        JetFormSection,
        JetInput,
        JetInputError,
        JetLabel,
        JetSecondaryButton,
        
    },
    data() {
        const page = this.$page || {};
        const props = page.props || {};
        const auth = props.auth || {};
        const user = auth.user || {};
        const incomingMessageAlerts = user?.meta?.incoming_message_alerts ?? false;

        return {
            form: this.$inertia.form(
                {
                    _method: "POST",
                    incoming_message_alerts: incomingMessageAlerts
                },
                {
                }
            ),
        }
    },
    methods: {
        updateSettings() {
            this.form.post("/user/settings", {
                preserveScroll: true,
                onSuccess: () => {
                    this.$toasted.show("Success!", {
                        position: "bottom-right",
                        type: "success",
                        duration: 3000
                    });
                },
            });
        },

    }
};
</script>
